module.exports = __webpack_public_path__ + "img/0-35.5e1b7557.jpg";